import dayjs, { Dayjs } from 'dayjs';

export const PICKUP_MIN_WINDOW_MINUTES = 120;

const FIRST_SLOT_MINUTES = 8 * 60;
const SLOT_STEP_MINUTES = 30;
const SLOT_COUNT = 25;
const PREFERRED_FROM = '09:00';
const PREFERRED_TO = '16:00';

export const pickupTimeToMinutes = (value: string): number => {
  const [hours, minutes] = value.split(':');
  return Number(hours) * 60 + Number(minutes);
};

const formatMinutes = (minutes: number): string =>
  `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

const ALL_SLOTS = Array.from({ length: SLOT_COUNT }, (_, index) =>
  formatMinutes(FIRST_SLOT_MINUTES + index * SLOT_STEP_MINUTES),
);

export const getPickupFromSlots = (pickupDate: string, now: Dayjs = dayjs()): string[] => {
  const isToday = dayjs(pickupDate).isSame(now, 'day');
  const nowMinutes = now.hour() * 60 + now.minute();
  const lastFrom = pickupTimeToMinutes(ALL_SLOTS[ALL_SLOTS.length - 1]) - PICKUP_MIN_WINDOW_MINUTES;
  return ALL_SLOTS.filter((slot) => {
    const minutes = pickupTimeToMinutes(slot);
    return minutes <= lastFrom && (!isToday || minutes > nowMinutes);
  });
};

export const getPickupToSlots = (from: string | undefined): string[] =>
  from
    ? ALL_SLOTS.filter(
        (slot) =>
          pickupTimeToMinutes(slot) - pickupTimeToMinutes(from) >= PICKUP_MIN_WINDOW_MINUTES,
      )
    : [];

export const getDefaultPickupWindow = (
  fromSlots: string[],
): { pickupHourFrom: string; pickupHourTo: string } => {
  const from = fromSlots.includes(PREFERRED_FROM) ? PREFERRED_FROM : (fromSlots[0] ?? '');
  const toSlots = getPickupToSlots(from);
  const to = toSlots.includes(PREFERRED_TO) ? PREFERRED_TO : (toSlots[0] ?? '');
  return { pickupHourFrom: from, pickupHourTo: to };
};
